module.exports = __webpack_public_path__ + "img/p_normalA@2x.0cd6fa58.png";